// What is selected on the board (slice 08), shared by the canvas (outside
// React) and the properties panel: a set of object ids. A player selects one
// thing at a time; the DM may box-select several (design/11 §6 — select
// across layers for reveal and delete, never for a group move, which is
// Phase 2). Nothing here touches the socket.
type Listener = (ids: ReadonlySet<string>) => void;

let selected: ReadonlySet<string> = new Set();
const listeners = new Set<Listener>();
const set = (next: ReadonlySet<string>) => { selected = next; for (const l of listeners) l(selected); };

export const selection = {
  get: () => selected,
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  },
  only(id: string): void { set(new Set([id])); },
  toggle(id: string): void { const n = new Set(selected); if (n.has(id)) n.delete(id); else n.add(id); set(n); },
  replace(ids: Iterable<string>): void { set(new Set(ids)); },
  clear(): void { if (selected.size) set(new Set()); },
  /** Things that left the table leave the selection. */
  keepOnly(existing: Set<string>): void {
    const n = new Set([...selected].filter((id) => existing.has(id)));
    if (n.size !== selected.size) set(n);
  },
};
